import { render, staticRenderFns } from "./input-validation-message.vue?vue&type=template&id=2ba4ff22&"
import script from "./input-validation-message.vue?vue&type=script&lang=js&"
export * from "./input-validation-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports